import { atom } from 'jotai'
import { endOfMonth, startOfMonth } from 'date-fns'
import { IssueType, IssueTypeWarrantConvertible } from '../types/IssueEntity'

/**
 * Atom representing the current page of the issue grid.
 */
export const issueGridCurrentPageAtom = atom(0)

/**
 * Atom representing the active tab in the issue section.
 */
export const issueActiveTabAtom = atom('current')

type FilterItem<T> = {
    disabledItems?: T
    hasMaxValueSet?: boolean
    includeGreaterValues?: boolean
    maxValue?: number
    value: T
}

export type IssueFilterType = {
    abb: FilterItem<string[]>
    onlyInWatchLists: FilterItem<boolean>
    warrants: FilterItem<string[]>
    issueTypes: FilterItem<IssueType[]>
    marketSize: FilterItem<number[]>
    preMoney: FilterItem<number[]>
    offeredSize: FilterItem<number[]>
    sectors: FilterItem<string[]>
    financialAdvisors: FilterItem<string[]>
    legalAdvisors: FilterItem<string[]>
    marketplaces: FilterItem<string[]>
    dates: FilterItem<Date[]>
    guarantors: FilterItem<string[]>
    issueTerms: FilterItem<string[]>
}

export const issueFiltersAtom = atom<IssueFilterType>({
    abb: { value: ['all'] },
    onlyInWatchLists: { value: false },
    warrants: { value: ['all'] },
    issueTypes: { disabled: [], value: ['Directed issue', 'IPO', 'Non-cash issue', 'Rights issue'] },
    marketSize: { value: [0, 500], maxValue: 500, includeGreaterValues: true, hasMaxValueSet: true },
    preMoney: { value: [0, 500], maxValue: 500, includeGreaterValues: true, hasMaxValueSet: true },
    offeredSize: { value: [0, 250], maxValue: 250, includeGreaterValues: true, hasMaxValueSet: true },
    sectors: { value: [] },
    financialAdvisors: { value: [] },
    legalAdvisors: { value: [] },
    marketplaces: {
        value: [],
    },
    dates: { value: [startOfMonth(new Date('2022-01-01')), endOfMonth(new Date())] },
    guarantors: { value: ['all'] },
    issueTerms: { value: ['all'] },
} as IssueFilterType)

export const issueTableDataAtom = atom({
    advisors: { value: ['financialAdvisors'] },
    priceChange: { value: ['postIssueMax'] },
})

export const newsFiltersAtom = atom({
    onlyInWatchLists: { value: false },
    issueTypes: {
        value: [
            'Rights issue',
            'Non-cash issue',
            'IPO',
            'ABB Directed issue',
            'Directed issue',
            'Warrant',
            'Convertible',
        ] as Exclude<IssueTypeWarrantConvertible, 'Guarantor fee issue'>[],
    },
    sourceType: {
        value: [] as string[],
    },
})

/**
 * Atom representing the search text input in the issue section.
 */
export const issueSearchTextfieldAtom = atom('')
